module.exports = __webpack_public_path__ + "img/_0.8aadb3e2.png";